var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2L2 7V22H22V7L12 2Z",
    fill: "#6B7280",
    stroke: "#374151",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H8V12H6V10Z",
    fill: "#374151"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H12V12H10V10Z",
    fill: "#374151"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10H16V12H14V10Z",
    fill: "#374151"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14H8V16H6V14Z",
    fill: "#374151"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H12V16H10V14Z",
    fill: "#374151"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H16V16H14V14Z",
    fill: "#374151"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H8V20H6V18Z",
    fill: "#374151"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H12V20H10V18Z",
    fill: "#374151"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H16V20H14V18Z",
    fill: "#374151"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10H20V22H18V10Z",
    fill: "#6B7280",
    stroke: "#374151",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10H6V22H4V10Z",
    fill: "#6B7280",
    stroke: "#374151",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.85879739f7e489ece6e63efc3249474b.svg";
export { ForwardRef as ReactComponent };